import React from "react";

const News = () => {
  return <div className="news">news</div>;
};

export default News;
